export const API_DOMAIN =
  process.env.API_URL
    ? process.env.API_URL
    : process.env.REACT_APP_NODE_ENV === "production"
      ? "https://sisapiiri.mtv.fi"
      : process.env.REACT_APP_NODE_ENV === "development"
        ? "http://localhost:9000"
        : "https://sisapiiri.mtv-stage.fi";

export const API_ROOT = `${API_DOMAIN}/`;



// WEBPACK FOOTER //
// ./src/api/constants.js